import { theme, styled } from 'ui/theme';
import { Text } from 'ui/components/primitives';

const SliderStyles = {
  Item: styled('div')`
    padding: ${theme.space[4]};
  `,

  Text: styled(Text)`
    color: ${theme.colors.build.darkLight};
  `,
};

export default SliderStyles;
